import React, { useEffect, useRef, useState } from 'react'
import styles from './assign.module.scss'
import { ProductInputs } from './productInputs'
import { useProductAttributesMutation, useProductCategoryListOptions } from '../../../features/product-selector';
import { MultiSelect as MultiSelectUntyped } from '../../primary';
import type { ApiEnvelope, KeyValueOption, ProductAttributeData, ProductAttributePayload, ProductFamilyOption } from '../../../features/product-selector';

interface MultiSelectHandle {
    resetSelectedValues: (mode?: unknown) => void;
    state: { selectedValues: KeyValueOption[] };
}

const MultiSelect = MultiSelectUntyped as unknown as React.ComponentType<{
    id?: string;
    name?: string;
    label?: React.ReactNode;
    classes?: Record<string, string>;
    optionValue: KeyValueOption[] | ProductFamilyOption[];
    displayValue?: string;
    showCheckbox?: boolean;
    onSelect?: (list: KeyValueOption[]) => void;
    onRemove?: (list: KeyValueOption[]) => void;
    validator?: (handle: MultiSelectHandle) => void;
    defaultValue?: KeyValueOption[];
}>;

interface ProductAttributeDivisionProps {
    fetchValue: (index: number, res: ApiEnvelope<ProductAttributeData> | undefined, productAttr: ProductAttributePayload) => void;
    index: number;
    defaultValue?: ProductAttributePayload;
}

export const ProductAttributeDivision: React.FC<ProductAttributeDivisionProps> = ({ fetchValue, index, defaultValue }) => {
    const { data: productCategoryList } = useProductCategoryListOptions();
    const { mutateAsync: fetchProductAttributes } = useProductAttributesMutation();
    const prodCat = useRef<MultiSelectHandle | null>(null);
    const prodFam = useRef<MultiSelectHandle | null>(null);

    useEffect(() => {
        fetchProductAttributes(defaultValue ?? {}).then((res) => {
            setAttributeList(res)
        })
    }, [defaultValue, fetchProductAttributes])

    useEffect(() => {
        const categoryDesc = productCategoryList?.data?.productCategoryDesc?.find((x) => x?.key === defaultValue?.division)
        if ((categoryDesc?.value?.length ?? 0) > 0) { setProductCat(categoryDesc?.value ?? []) }
    }, [defaultValue, productCategoryList?.data?.productCategoryDesc])

    useEffect(() => {
        let familyCode: ProductFamilyOption[] = [];
        defaultValue?.productCategoryDesc?.map((item) => {//NOSONAR
            const productFamilCode = productCategoryList?.data?.productFamilyDesc?.find((x) => x?.key === item)
            if ((productFamilCode?.value?.length ?? 0) > 0) { familyCode = [...familyCode, ...(productFamilCode?.value ?? [])] }//NOSONAR
        })//NOSONAR
        setProductFamilyCode(familyCode)
    }, [productCategoryList, defaultValue])

    useEffect(() => {
        setGetOptions(defaultValue ?? {})
    }, [defaultValue])

    const [getOptions, setGetOptions] = useState<ProductAttributePayload>({})
    const [productCat, setProductCat] = useState<KeyValueOption[]>([])
    const [productFamilyCode, setProductFamilyCode] = useState<ProductFamilyOption[]>([])
    const [attributeList, setAttributeList] = useState<ApiEnvelope<ProductAttributeData> | undefined>(undefined)
    const getAttributes = (data: string | number) => {
        prodCat.current?.resetSelectedValues([]);
        prodFam.current?.resetSelectedValues([]);
        const categoryDesc = productCategoryList?.data?.productCategoryDesc?.find((x) => x?.key === data)
        if ((categoryDesc?.value?.length ?? 0) > 0) { setProductCat(categoryDesc?.value ?? []) }
        fetchProductAttributes({ division: data } as ProductAttributePayload).then((res) => {
            setAttributeList(res)
        })
        setGetOptions({ division: data } as ProductAttributePayload)
        setDivision(false)
        setDefaultData(false);
    }

    const getAttributeValue = (value: Partial<ProductAttributePayload>) => {
        if (value.productAttribute !== undefined && (value.productAttribute as unknown) !== "") {
            setAttribute(false)
        }
        let data = { ...getOptions, ...value }
        setGetOptions(data)
    }

    const [division, setDivision] = useState(false)

    const [attribute, setAttribute] = useState(false)

    const [defaultData, setDefaultData] = useState(true)

    const fetchOption = () => {
        let productAttr: ProductAttributePayload & { fetchResult?: number } = { ...getOptions }
        productAttr['fetchResult'] = 1
        const divisionVal = productAttr['division'];
        const categoryDesc = productAttr['productCategoryDesc'];
        const familyDesc = productAttr['productFamilyDesc']
        const productAtt = productAttr['productAttribute'];
        if ((divisionVal as unknown) === 0 || divisionVal === undefined || (divisionVal as unknown) === '') {
            setDivision(true)
        } else {
            setDivision(false)
        }
        if ((categoryDesc as unknown) === 0 || categoryDesc === undefined) {
            productAttr['productCategoryDesc'] = []
        }
        if ((familyDesc as unknown) === 0 || familyDesc === undefined) {
            productAttr['productFamilyDesc'] = []
        }
        if ((productAtt as unknown) === 0 || productAtt === undefined || (productAtt as unknown) === '') {
            setAttribute(true)
        } else {
            setAttribute(false)
        }
        if (divisionVal && productAtt) {
            fetchProductAttributes(productAttr).then((res) => {
                fetchValue(index, res, productAttr)
                setAttributeList(res)
            })
        }
    }

    const selectCategoryDesc = (list: KeyValueOption[]) => {
        prodFam.current?.resetSelectedValues();
        let prodcutCat: number[] = [];
        let productFamilyDes: ProductFamilyOption[] = [];
        list.map((item) => {
            prodcutCat = [...prodcutCat, item.key]
            const categoryDesc = productCategoryList?.data?.productFamilyDesc?.find((x) => x?.key === item.key)
            productFamilyDes = [...productFamilyDes, ...(categoryDesc?.value ?? [])]//NOSONAR
        })
        const cat = { productCategoryDesc: prodcutCat }
        const filter = { ...getOptions, ...cat }
        setGetOptions(filter);
        setProductFamilyCode(productFamilyDes);
        fetchProductAttributes(filter).then((res) => {
            setAttributeList(res)
        })
    }

    const selectProductFamilyDesc = (list: KeyValueOption[]) => {
        let productFamily: number[] = [];
        list.map((item) => {
            productFamily = [...productFamily, item.key]
        })
        const family = { productFamilyDesc: productFamily }
        const filter = { ...getOptions, ...family }
        setGetOptions(filter)
        fetchProductAttributes(filter).then((res) => {
            setAttributeList(res)
        })
    }
    return (
        <>
            <ProductInputs
                label="Product Division"
                id={`productDivision${index}`}
                classes={{
                    column: `col-6 ${styles.col_spec}`,
                    inputClassName: `${styles.prod_select_search}`,
                    labelClassName: `col-5  col-form-label ${styles.label_spec}`,
                    inputColumn: `col-7 p-0 ${styles.select_wrapper} ${styles.select_wrapper_pro}`
                }}
                required={true}
                listData={productCategoryList?.data?.division}
                getValue={(val) => getAttributes(val)}
                error={division ? 'Please Select Product Division' : ''}
                defaultValue={defaultValue?.division}
            />

            <MultiSelect
                id={"categoryDesc"}
                name={"categoryDesc"}
                label={`Category Description`}
                classes={{
                    column: `col-6 ${styles.col_spec}`,
                    inputClassName: `${styles.prod_select_search}`,
                    labelClassName: `col-5  col-form-label ${styles.label_spec}`,
                    inputColumn: `col-7 p-0 ${styles.select_wrapper}`
                }}
                optionValue={productCat}
                displayValue="value"
                showCheckbox={true}
                onSelect={(list) => selectCategoryDesc(list)}
                onRemove={(list) => selectCategoryDesc(list)}
                validator={(e) => {
                    prodCat.current = e
                }}
                defaultValue={defaultData ? defaultValue?.productCategoryDesc as unknown as KeyValueOption[] : []}
            />

            <MultiSelect
                id={"productFamilyDesc"}
                name={"productFamilyDesc"}
                label={`Product Family Description`}
                classes={{
                    column: `col-6 ${styles.col_spec} pt-2`,
                    inputClassName: `${styles.prod_select_search}`,
                    labelClassName: `col-5  col-form-label ${styles.label_spec}`,
                    inputColumn: `col-7 p-0 ${styles.select_wrapper}`
                }}
                optionValue={productFamilyCode}
                displayValue="value"
                showCheckbox={true}
                onSelect={(list) => selectProductFamilyDesc(list)}
                onRemove={(list) => selectProductFamilyDesc(list)}
                validator={(e) => {
                    prodFam.current = e
                }}
                defaultValue={defaultData ? defaultValue?.productFamilyDesc as unknown as KeyValueOption[] : []}
            />

            <ProductInputs
                label="Product Attribute"
                id={`productAttribute${index}`}
                classes={{
                    column: `col-6 ${styles.col_spec} pt-2`,
                    inputClassName: `${styles.prod_select_search}`,
                    labelClassName: `col-5  col-form-label ${styles.label_spec}`,
                    inputColumn: `col-7 p-0 ${styles.select_wrapper} ${styles.select_wrapper_pro}`
                }}
                required={true}
                listData={attributeList?.data?.productAttribute}
                getValue={(key, value) => getAttributeValue({ productAttribute: key as number, productAttributeLabel: value })}
                error={attribute ? 'Please Select Product Attribute' : ''}
                defaultValue={getOptions?.productAttribute}
            />
            <div className={`col-12 ${styles.col_spec} align-items-end justify-content-end`}>
                <div className={`btn ${styles.btn_fetch}`} onClick={() => fetchOption()}>Fetch</div>
            </div>
        </>
    )
}
